import { Product } from '../models/product.model';

// Couleur unique pour le badge de pourcentage (demandé explicitement : une seule
// couleur plutôt que des paliers), teinte orangé-rouge choisie par l'utilisateur.
export function discountColor(_product: Product): string {
  return '#e24a1c';
}
